import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { operations } from './generated/gcss';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { GCSS_URLS } from '@/constants/api';
import { apiGcssFetcher } from '../fetcher';
export type ProductListResponse = operations['products']['responses']['200']['content']['application/json'] | undefined;
export type Product = NonNullable<ProductListResponse>['data'][number];
type QueryParams = operations['products']['parameters']['query'];
export function useGcssProductList(t0) {
  const $ = _c(12);
  let enabled;
  let params;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      enabled,
      ...params
    } = t0);
    t2 = useInfiniteQuery;
    t1 = QUERY_KEYS.gcssProductList(params);
    $[0] = t0;
    $[1] = enabled;
    $[2] = params;
    $[3] = t1;
    $[4] = t2;
  } else {
    enabled = $[1];
    params = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== params) {
    t3 = async t4 => {
      const {
        pageParam,
        signal
      } = t4;
      const res = await apiGcssFetcher(GCSS_URLS.productList, {
        searchParams: {
          ...params,
          ...(pageParam || {})
        },
        signal
      });
      return res.json;
    };
    $[5] = params;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {};
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== enabled || $[9] !== t1 || $[10] !== t3) {
    t5 = {
      queryKey: t1,
      queryFn: t3,
      getNextPageParam: _temp,
      getPreviousPageParam: _temp2,
      initialPageParam: t4,
      enabled,
      placeholderData: keepPreviousData,
      staleTime: 60000,
      refetchOnWindowFocus: false,
      retry: 2,
      retryDelay: 1000
    };
    $[8] = enabled;
    $[9] = t1;
    $[10] = t3;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t2(t5);
}
function _temp2(page_0) {
  if (!page_0) {
    return;
  }
  const before = new URLSearchParams(new URL(`${process.env.NEXT_PUBLIC_GCSS_API_URL}${page_0?.pagingInfo.prevPage}`).searchParams).get("before");
  return before ? {
    before
  } : undefined;
}
function _temp(page) {
  if (!page) {
    return;
  }
  const after = new URLSearchParams(new URL(`${process.env.NEXT_PUBLIC_GCSS_API_URL}${page?.pagingInfo.nextPage}`).searchParams).get("after");
  return after ? {
    after
  } : undefined;
}